<div style="height: 100%" id="div_25afd4bf">
  <router-outlet></router-outlet>
</div>
